module.exports = __webpack_public_path__ + "static/welcome-ebbac4f0fabfd2be9ef6a1c73016456c.jpg";